import script from "./SiteTicker.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteTicker.vue?vue&type=script&setup=true&lang=js"

import "./SiteTicker.vue?vue&type=style&index=0&id=be5cdd16&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be5cdd16"]])

export default __exports__